import { Mapper } from "../../../../base/utils/mapper";
import { BackgroundResponseModel } from "../../../../domain/models/consult/background-response.model";
import { BackgroundResponseEntity } from "../entities/background-response.entity";



export class BackgroundImplementationRepositoryMapper extends Mapper<BackgroundResponseEntity, BackgroundResponseModel> {
    mapFrom(param: BackgroundResponseEntity): BackgroundResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: BackgroundResponseModel): BackgroundResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}